export default __webpack_public_path__ + "static/media/ArIT.4ad993c8.png";